const tabCfgAry = [
  {
    key: "user",
  },
  {
    key: "usds",
    labelKey: "market.subTabCrypto",
    buyCoinAry: ["usdt", "pax", "tusd", "ausd", "usdc", "ust", "xtusd", "busd"],
  },
  {
    key: "btc",
    label: "BTC",
    buyCoinAry: ["btc"],
  },
  {
    key: "eth",
    label: "ETH",
    buyCoinAry: ["eth"],
  },
  {
    key: "fiat",
    labelKey: "market.subTabCrypto",
    buyCoinAry: ["aed", "brl", "sar"],
  },
  {
    key: "stocks",
    labelKey: "market.subTabStocks",
  },
  {
    key: "commodities",
    labelKey: "market.subTabCommodities",
  },
  {
    key: "xt",
    label: "XT",
    buyCoinAry: ["xt"],
    group: "ALTS",
  },
  {
    key: "bnb",
    label: "BNB",
    buyCoinAry: ["bnb"],
    group: "ALTS",
  },
  {
    key: "bitci",
    label: "BITCI",
    buyCoinAry: ["bitci"],
    group: "ALTS",
  },
  {
    key: "matic",
    label: "MATIC",
    buyCoinAry: ["matic"],
    group: "ALTS",
  },
  {
    key: "zone",
  },
];

export default tabCfgAry;
